import { api } from "../../lib/api";
import { useGameStore } from "../../store/gameStore";
import { DoorOpen } from "lucide-react";
import { toast } from "sonner";

// GM-only: appears the moment a player opens a door in regular (non-Free-Roam) play, since the
// whole table shares one live map — the GM decides whether just that one player slips through or
// the whole party gets moved together.
export default function DoorPromptBar({ gameId, isGm }) {
  const pending = useGameStore((s) => s.pendingDoorTrigger);
  const setPending = useGameStore((s) => s.setPendingDoorTrigger);

  if (!isGm || !pending) return null;

  const resolve = async (mode) => {
    try {
      await api.post(`/games/${gameId}/doors/${pending.door_id}/resolve`, { mode, token_id: pending.token_id });
      toast.success(mode === "all" ? "The whole party steps through" : `${pending.token_name} steps through alone`);
    } catch {
      toast.error("Could not resolve the door");
    } finally {
      setPending(null);
    }
  };

  return (
    <div className="absolute top-16 left-1/2 -translate-x-1/2 z-30 flex items-center gap-3 bg-[#151315]/95 panel-wood px-4 py-2 shadow-xl" data-testid="door-prompt-bar">
      <DoorOpen className="w-4 h-4 text-[#D4AF37] shrink-0" />
      <span className="text-xs text-[#f1e0c5]/80">{pending.token_name} opened "{pending.door_name || "a door"}" — send through:</span>
      <button data-testid="door-prompt-send-single" onClick={() => resolve("single")} className="text-[10px] px-3 py-1 rounded-full border border-[#D4AF37]/40 text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-colors duration-200">
        Just Them
      </button>
      <button data-testid="door-prompt-send-all" onClick={() => resolve("all")} className="text-[10px] px-3 py-1 rounded-full bg-[#1E3A8A] hover:bg-[#2b4fab] text-white transition-colors duration-200">
        Everyone
      </button>
      <button data-testid="door-prompt-dismiss" onClick={() => setPending(null)} className="text-[#f1e0c5]/40 hover:text-white text-xs">
        Dismiss
      </button>
    </div>
  );
}
